import React, { Suspense, useMemo } from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import { useMobile } from 'utils/media';
import Text from 'components/Text';
import Slider from 'components/Slider';
import MobileSlider from 'components/Slider/MobileSlider';
import { FrontSpecialistTeaser } from 'components/SpecialistTeaser';
import { TeaserSkeleton } from 'components/SpecialistTeaser/FrontSpecialistTeaser';
import { IconButton } from 'components/Button';
import { times } from 'utils/render';
import Model from '../../../../model';
import './index.sass';

const { block, el } = bem('front-specialists');

const Specialists = () => {
    const { isMobile } = useMobile();
    const { specialistsData } = Model.specialist;
    const SpecialistsSlider = isMobile ? MobileSlider : Slider;
    const Fallback = <SpecialistsSlider items={ times(() => <TeaserSkeleton/>, 3) }/>
    return (
        <div className={ block() }>
            <div className={ el('top-block') }>
                <div className={ el('title') }><Text serif>Наши специалисты</Text></div>
                <div className={ el('description') }>
                    <Text>
                        В команде «Ответ» работают специалисты разных направлений и методов, с каждым из них мы провели
                        несколько этапов собеседования, изучили образование, опыт, компетенции и профессиональную
                        репутацию. Поэтому, выбирая терапевта, вы можете быть абсолютно спокойны и доверять своему
                        эмоциональному отклику.
                    </Text>
                </div>
            </div>
            <div className={ el('slider') }>
                <Suspense fallback={ Fallback }>
                    <SliderBlock resource={ specialistsData } isMobile={ isMobile }/>
                </Suspense>
            </div>
            { isMobile && <div className={ el('button') }>
                <IconButton name={ 'arrow-right' } to={ '/specialists' } mod={ 'transparent-gold' }>
                    <Text>Все специалисты</Text>
                </IconButton>
            </div> }
        </div>
    );
};

const SliderBlock = observer(({ resource, isMobile }) => {
    const specialists = resource.read();
    const teasers = useMemo(() => specialists.length > 0 ? specialists.map(spec => <FrontSpecialistTeaser
        specialist={ spec }/>) : [], []);
    const SpecialistsSlider = isMobile ? MobileSlider : Slider;
    return <SpecialistsSlider items={ teasers }/>
});

export default observer(Specialists);

